import _URLSearchParams from "@babel/runtime-corejs3/core-js-stable/url-search-params";

/*
 * @Author: Nanxing Xiang
 * @Date: 2021-04-14 11:15:43
 * @LastEditors: Nanxing Xiang
 * @LastEditTime: 2021-04-14 11:21:28
 * @Description: file content
 */
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
export default function useSearchParams(key) {
  var location = useLocation();
  return useMemo(function () {
    var params = new _URLSearchParams(location.search);
    return key ? params.get(key) : params;
  }, [key, location.search]);
}